/**
 * The little Markdown the Guide's text uses — **bold**, `code`, numbered and
 * bulleted lists, paragraphs — rendered to HTML after escaping everything
 * else, so text from a manual can never inject markup.
 */
export function guideMarkdown(source: string): string {
    const lines = (source || '').replace(/\r/g, '').split('\n');
    const html: string[] = [];
    let list: 'ol' | 'ul' | null = null;
    let paragraph: string[] = [];
    const flushParagraph = () => {
        if (paragraph.length) {
            html.push(`<p>${guideInline(paragraph.join(' '))}</p>`);
            paragraph = [];
        }
    };
    const closeList = () => {
        if (list) {
            html.push(`</${list}>`);
            list = null;
        }
    };
    lines.forEach(raw => {
        const line = raw.trim();
        const numbered = /^\d+[.)]\s+(.*)$/.exec(line);
        const bullet = /^[-*•]\s+(.*)$/.exec(line);
        if (numbered || bullet) {
            flushParagraph();
            const kind = numbered ? 'ol' : 'ul';
            if (list !== kind) {
                closeList();
                html.push(`<${kind}>`);
                list = kind;
            }
            html.push(`<li>${guideInline((numbered || bullet)![1])}</li>`);
        } else if (!line) {
            flushParagraph();
            closeList();
        } else {
            closeList();
            paragraph.push(line);
        }
    });
    flushParagraph();
    closeList();
    return html.join('');
}

/** One line: escaped, then **bold** and `code`. */
export function guideInline(text: string): string {
    return escapeHtml(text)
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
}

function escapeHtml(text: string): string {
    return (text || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));
}
